/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { request as __request } from '../core/request';
import { NewsArticle } from '../models/NewsArticle';
import { NewsDeleteRequest } from '../models/NewsDeleteRequest';

export class NewsService {
    /**
     * @returns Array<NewsArticle> OK
     * @throws ApiError
     */
    public static async getNews()
    : Promise<Array<NewsArticle>> {
        const result = await __request({
            method: 'GET',
            path: `/api/News`,
        });
        return result.body;
    }

    /**
     *  * @param stub
     * @returns NewsArticle OK
     * @throws ApiError
     */
    public static async getNewsByStub(
    stub: string,
    ): Promise<NewsArticle> {
        const result = await __request({
            method: 'GET',
            path: `/api/News/${stub}`,
        });
        return result.body;
    }

    /**
     * @param requestBody 
     * @returns NewsArticle OK
     * @throws ApiError
     */
    public static async createNews(
    requestBody?: NewsArticle,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/News`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody 
     * @returns NewsArticle OK
     * @throws ApiError
     */
    public static async updateNews(
    requestBody?: NewsArticle,
    ): Promise<NewsArticle> {
        const result = await __request({
            method: 'PUT',
            path: `/api/News`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static async deleteArticle(
    requestBody?: NewsDeleteRequest,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/News`,
            body: requestBody,
        });
        return result.body;
    }
}